import React from 'react';
import { BodyText, Button, DataGrid, NavigationItem } from 'ui-toolkit';
import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-regular-svg-icons';
import { IPresentationThirdPartyContact, IThirdPartyContactData } from '../../../../types/contacts/IThirdPartyContact';
import { formatPhoneNumber } from '../../../../utilities/shared/formatPhoneNumber';
import { getListOfPresentationContacts } from '../../../../types/contacts/IPresentationContactData';
import { IContactFunctionData } from '../../../../types/contacts/IContactFunctionData';

interface IThirdPartyContactsTableProps {
  data: IThirdPartyContactData[];
  loading: boolean;
  onEditContact: (contact: IThirdPartyContactData) => void;
  contactFunctions: IContactFunctionData[];
}

export const ThirdPartyContactsTable: React.FC<IThirdPartyContactsTableProps> = ({
  data,
  loading,
  onEditContact,
  contactFunctions,
}) => {
  const tableData: IPresentationThirdPartyContact[] = getListOfPresentationContacts(
    data,
    contactFunctions.filter((func) => func.isThirdParty).map((func) => func.id)
  );
  const columns: IBootstrapTableColumnProps[] = [
    {
      text: 'Function',
      dataField: 'function',
      sort: true,
      formatter: (cell: string) => <>{contactFunctions.find((func) => func.id === cell)?.label}</>,
    },
    {
      text: 'Name',
      dataField: 'firstName',
      sort: true,
      formatter: (cell, row) => (
        <>{`${(row as IPresentationThirdPartyContact).firstName} ${
          (row as IPresentationThirdPartyContact).lastName
        }`}</>
      ),
    },
    {
      text: 'Email',
      dataField: 'emailAddress',
      sort: true,
      formatter: (cell) => <NavigationItem href={`mailto:${cell}`} text={cell} isActive isInline />,
    },

    {
      text: 'Phone',
      dataField: 'phoneNumber',
      sort: true,
      formatter: (cell) => <>{formatPhoneNumber(cell || '')}</>,
    },
    {
      text: 'Company Name',
      dataField: 'companyName',
      sort: true,
    },
    {
      text: 'Notes',
      dataField: 'notes',
      sort: true,
      formatter: (cell) => <BodyText style={{ whiteSpace: 'pre-line' }}>{cell}</BodyText>,
    },
    {
      text: 'Options',
      dataField: 'id',
      formatter: (cell, row) => (
        <Button intent={'ghost'} onClick={() => onEditContact(row as IThirdPartyContactData)}>
          <FontAwesomeIcon icon={faEdit} />
        </Button>
      ),
    },
  ];

  return <DataGrid columns={columns} keyField={'key'} data={tableData} loading={loading} />;
};
